'use strict';

var rippleAddressCodec = require('ripple-address-codec');
var y = require('yup');

function _interopNamespaceCompat(e) {
  if (e && typeof e === 'object' && 'default' in e) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'ripple';
const RIPPLE_ERROR = 'ripple';
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? RIPPLE_ERROR
        },
        test: (value)=>{
            try {
                return rippleAddressCodec.isValidClassicAddress(String(value));
            } catch  {
                return false;
            }
        }
    });
});

exports.RIPPLE_ERROR = RIPPLE_ERROR;
//# sourceMappingURL=ripple.js.map
